import { Component } from "react"
import PropTypes from "prop-types"
import { WorksWithContent } from "./works_with_content"
import { connectionShape } from "app/lib/shared_prop_types"
import { formatHexColorValue } from "shared/lib/alternate_brand_color"
import ConnectButton from "shared/components/connection_card/connect_button/index"

import { compactInteger } from "humanize-plus"
import appletOrConnection from "shared/lib/use_applet_or_connection"
import userIconPng from "images/web/applet_card/user-icon.png"

import "./small_applet_card.scss"

export default class Meta extends Component {
  render() {
    const {
      appearDisabled,
      applet,
      href,
      mainService,
      onAppletClick,
      showConnectButton,
    } = this.props

    const humanizedInstallNumber = compactInteger(applet.installs_count, 1)
    const appletType = appletOrConnection(applet)
    const isConnected = applet.status === "enabled_for_user"
    const background = applet.background_images?.sm_background_image_url
      ? "rgba(0, 0, 0, 0.5)"
      : "rgba(0, 0, 0, 0.3)"
    const handleOnClick = event => {
      event && onAppletClick(event)
      href && (window.Turbolinks?.visit(href) || window.location(href))
    }

    return (
      <>
        {showConnectButton && (
          <div styleName="small-connect-button">
            <ConnectButton
              smallFlavor
              mainService={mainService}
              onConnectClick={handleOnClick}
              connected={isConnected}
              defaultBgColor={{ background }}
              knobBgColor={{
                boxShadow: "none",
                backgroundColor:
                  isConnected && !appearDisabled
                    ? formatHexColorValue(mainService.brand_color)
                    : "#AAA",
              }}
              knobBgColorForDarkBrands={
                mainService.brand_color.indexOf("000") !== -1
              }
              connectButtonMaxFontSize={14}
            />
          </div>
        )}
        <div className="meta">
          {applet.installs_count > 0 && (
            <div
              className="installs"
              aria-label={`${humanizedInstallNumber} users`}
              title={`${humanizedInstallNumber} users enabled this ${appletType}`}
            >
              <span className="verified">
                <img src={userIconPng} alt="user icon" loading="lazy" width="14" height="18" />
              </span>
              <span>{humanizedInstallNumber}</span>
            </div>
          )}
          <WorksWithContent applet={applet} mainService={mainService} />
        </div>
      </>
    )
  }
}

Meta.propTypes = {
  applet: connectionShape.isRequired,
  mainService: PropTypes.object,
  href: PropTypes.string,
  onAppletClick: PropTypes.func,
  appearDisabled: PropTypes.bool,
  showConnectButton: PropTypes.bool,
}

Meta.defaultProps = {
  appearDisabled: false, // the applet appears disabled to show the user they will lose the applet
  showConnectButton: true,
}
